import React, { Component } from "react";
import { Box } from "reactjs-admin-lte";
import {
  Form,
  Row,
  Col,
  FormGroup,
  FormControl,
  Button,
  SplitButton,
  ButtonToolbar,
  ControlLabel,
  DropdownButton,
  MenuItem,
} from "react-bootstrap";
import { tableHelper, momentHelper } from "./helpers";
import ReactPaginate from "react-paginate";
import "./report.css";
import FontAwesome from "react-fontawesome";
import Select from "react-select";
import FontAwsome from "react-fontawesome";
import SelectDate from "../../component/element/SelectDate";
import IframeModal from "../../component/element/IframeModal";
import CKAutocomplete from "../../component/element/CKAutocomplete";
import WorkdocStore from "../../stores/WorkdocStore";
import DatePicker from "../../component/element/DatePicker";
import withSizes from "react-sizes";
import ReportMobileTable from "./ReportMobileTable";
import { connect } from "react-redux";
import PrintButtons from "component/element/PrintButtons";
import $ from "jquery";
import XLSX from "xlsx";
import FileSaver from "file-saver";
const optionsRows = [0, 10, 20, 50, 100];
class ReportGeneralTable extends Component {
  constructor(props) {
    super(props);
    const month = momentHelper.getMonth();
    const year = momentHelper.getYear();
    const day = momentHelper.getDay();
    const searchBy = this.props.searchBy;
    const query = "";
    //const data = this.requestData(year, month, searchBy, query)

    this.state = {
      month: month,
      year: year,
      day: "00",
      searchBy: searchBy,
      query: query,
      pageCount: 1,
      activePage: 0,
      itemPerPage: 20,
      loading: false,
      data: [],
      showCountCredit: false,
      credit: "",
      showInsurance: false,
      insuranceOption: [{ label: "----- เลือกบริษัทประกัน -----", value: "" }],
      insuranceName: "",
      isRange: false,
      yearRange: year,
      monthRange: month,
      dayRange: day,
      isShopName: false,
      optionsShopName: [],
      year_series: "",
      sum_amount: 0,
      dataExcel: [],
      optionsRows: optionsRows,
    };
    this.refTableId = "ReportGeneralTable-" + Math.ceil(Math.random() * 100);
  }

  getNumberFormat(value, decimal = 2) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  componentDidMount() {
    $("body").on("click", () => {
      if ($(".Select").hasClass("is-open"))
        $(".table-responsive").css("overflow-x", "initial");
      else $(".table-responsive").css("overflow-x", "auto");
    });

    if (this.props.onRef !== undefined) {
      this.props.onRef(this);
    }
    if (!this.props.callOut) {
      let { year, month, day, searchBy, query, activePage, itemPerPage } =
        this.state;
      if (!this.props.loadOnShow || this.props.loadFirst) {
        if (this.props.autoQuery !== null) {
          query = this.props.autoQuery;
          this.setState({ query: query });
        } else {
          query = "";
          this.setState({ query: query });
        }
        this.loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage
        );
      }
    }
  }

  componentWillReceiveProps(newProps) {
    if (
      (newProps.loadOnShow &&
        newProps.show &&
        this.props.show !== newProps.show) ||
      (newProps.docClose && newProps.docClose !== this.props.docClose)
    ) {
      let { year, month, day, searchBy, query, activePage, itemPerPage } =
        this.state;
      this.loadData(year, month, day, searchBy, query, activePage, itemPerPage);
    }
  }

  loadInsuranceOption(year, month, day) {
    this.setState({ loading: true });
    let { insuranceOption } = this.state;
    insuranceOption = [{ label: "----- เลือกบริษัทประกัน -----", value: "" }];
    WorkdocStore.loadInsuranceOption(
      this.props.docType,
      this.props.viewMode,
      year,
      month,
      day,
      (result) => {
        result.data.forEach((item, index) => {
          insuranceOption.push({ label: item.name, value: item.name });
        });
        this.setState({
          insuranceOption: insuranceOption,
          insuranceName: "",
          loading: false,
        });
      },
      () => {
        this.setState({
          insuranceOption: insuranceOption,
          insuranceName: "",
          loading: false,
        });
      }
    );
  }

  loadShopNameOption() {
    this.setState({ loading: true });
    let { optionsShopName, query } = this.state;
    optionsShopName = [];
    WorkdocStore.loadShopList(
      query,
      (result) => {
        result.data.forEach((item, index) => {
          optionsShopName.push({ label: item.Name, value: item.Name });
        });
        this.setState({ optionsShopName: optionsShopName, loading: false });
      },
      () => {
        this.setState({ optionsShopName: optionsShopName, loading: false });
      }
    );
  }

  refreshTable() {
    let { year, month, day, searchBy, query, activePage, itemPerPage } =
      this.state;
    this.loadData(year, month, day, searchBy, query, activePage, itemPerPage);
  }

  refreshRange() {
    this.setState({ isRange: false, pageCount: 0, activePage: 0 });
  }

  setPaging(data_count, itemPerPage) {
    this.setState({ pageCount: Math.ceil(data_count / itemPerPage) });
  }

  onDayChange(val) {
    let { year, month, day, searchBy, query, itemPerPage, showInsurance } =
      this.state;
    day = val.value;
    this.setState({
      day: day,
      isRange: false,
      activePage: 0,
    });

    if (showInsurance) this.loadInsuranceOption(year, month, day);
    else this.loadData(year, month, day, searchBy, query, 0, itemPerPage);
  }

  onMonthChange(val) {
    let { year, month, day, searchBy, query, itemPerPage, showInsurance } =
      this.state;
    month = val.value;
    this.setState({ month: month, isRange: false, activePage: 0 });

    if (showInsurance) this.loadInsuranceOption(year, month, day);
    else this.loadData(year, month, day, searchBy, query, 0, itemPerPage);
  }

  onYearChange(val) {
    let { year, month, day, searchBy, query, itemPerPage, showInsurance } =
      this.state;
    year = val.value;
    this.setState({
      year: year,
      isRange: false,
      activePage: 0,
    });

    if (showInsurance) this.loadInsuranceOption(year, month, day);
    else this.loadData(year, month, day, searchBy, query, 0, itemPerPage);
  }

  onSearchOptionChange(val) {
    let {
      year,
      month,
      day,
      searchBy,
      query,
      itemPerPage,
      showCountCredit,
      showInsurance,
      isShopName,
    } = this.state;
    searchBy = val.value;
    showInsurance = false;
    if (val.value === "shop_name") {
      showCountCredit = true;
      this.loadShopNameOption();
      isShopName = true;
    } else if (val.value === "insurance_name") {
      showInsurance = true;
      isShopName = false;
      this.loadInsuranceOption(year, month, day);
    } else {
      showCountCredit = false;
      isShopName = false;
    }

    this.setState({
      activePage: 0,
      searchBy: searchBy,
      showCountCredit: showCountCredit,
      showInsurance: showInsurance,
      isShopName: isShopName,
    });
    if (val.value !== "insurance_name")
      this.loadData(year, month, day, searchBy, query, 0, itemPerPage);
  }

  onInsuranceOptionChange(e) {
    let { year, month, day, searchBy, itemPerPage } = this.state;
    this.loadData(year, month, day, searchBy, e.value, 0, itemPerPage);
    this.setState({ insuranceName: e.value, activePage: 0, query: e.value });
  }

  onYearSeriesKeyPress(target) {
    if (target.charCode === 13) {
      this.onSearchClick();
    }
  }

  onYearSeriesChange(e) {
    this.setState({ year_series: e.target.value });
  }

  onSearchKeyPress(target) {
    let { year, month, day, searchBy, query, itemPerPage } = this.state;
    let { autoRowSelect } = this.props;
    if (target.charCode === 13) {
      this.setState({ activePage: 0 });
      this.loadData(
        year,
        month,
        day,
        searchBy,
        query,
        0,
        itemPerPage,
        false,
        false,
        (data) => {
          if (autoRowSelect !== undefined) {
            if (autoRowSelect.includes(searchBy) && data.length > 0) {
              let checkQuery = false;
              let key = -1;
              autoRowSelect.forEach((item, index) => {
                key = data.findIndex((x) => x[item] === query);
                if (key !== -1) checkQuery = true;
              });
              if (checkQuery && this.props.onRowSelect !== undefined)
                this.props.onRowSelect(data[key]);
            }
          }
        }
      );
      this.setState({ isRange: false });
    }
  }

  onSearchClick() {
    let { year, month, day, searchBy, query, itemPerPage } = this.state;
    let { autoRowSelect } = this.props;
    this.setState({
      submitQuery: this.state.query,
      isRange: false,
      activePage: 0,
    });

    this.loadData(
      year,
      month,
      day,
      searchBy,
      query,
      0,
      itemPerPage,
      false,
      false,
      (data) => {
        if (autoRowSelect != undefined) {
          if (autoRowSelect.includes(searchBy) && data.length > 0) {
            let checkQuery = false;
            let key = -1;
            autoRowSelect.forEach((item, index) => {
              key = data.findIndex((x) => x[item] == query);
              if (key != -1) checkQuery = true;
            });
            if (checkQuery && this.props.onRowSelect != undefined)
              this.props.onRowSelect(data[key]);
          }
        }
      }
    );
  }

  onQueryChange(e) {
    let { query } = this.state;
    query = e.target.value;
    this.setState({ query: query });

    // this.loadData(year, month, day, searchBy, query)
  }

  onPageChange(page) {
    //console.log('pageChagne', page)
    let {
      year,
      month,
      day,
      searchBy,
      query,
      activePage,
      itemPerPage,
      yearRange,
      monthRange,
      dayRange,
    } = this.state;
    activePage = page.selected;
    this.setState({ activePage: activePage });
    if (!this.state.isRange) {
      if (
        this.props.docType === "invoice" ||
        this.props.docType === "withholdingtax"
      )
        this.loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage,
          false,
          true
        );
      else
        this.loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage
        );
    } else {
      year = year - 543;
      yearRange = yearRange - 543;
      let start =
        (day === "0" || day === 0 ? 1 : day) +
        "/" +
        (month === "00" ? "1" : month) +
        "/" +
        year;
      let end = dayRange + "/" + monthRange + "/" + yearRange;
      this.loadDataRange(start, end, searchBy, query, activePage, itemPerPage);
    }
  }

  onRowsPerPageChange(e) {
    let {
      year,
      month,
      day,
      searchBy,
      query,
      activePage,
      itemPerPage,
      yearRange,
      monthRange,
      dayRange,
    } = this.state;
    itemPerPage = e;

    this.setState({ itemPerPage: itemPerPage }, () => {
      if (!this.state.isRange) {
        if (
          this.props.docType === "invoice" ||
          this.props.docType === "withholdingtax"
        )
          this.loadData(
            year,
            month,
            day,
            searchBy,
            query,
            activePage,
            itemPerPage,
            false,
            true
          );
        else
          this.loadData(
            year,
            month,
            day,
            searchBy,
            query,
            activePage,
            itemPerPage
          );
      } else {
        year = year - 543;
        yearRange = yearRange - 543;
        let start =
          (day === "0" || day === 0 ? 1 : day) +
          "/" +
          (month === "00" ? "1" : month) +
          "/" +
          year;
        let end = dayRange + "/" + monthRange + "/" + yearRange;
        this.loadDataRange(
          start,
          end,
          searchBy,
          query,
          activePage,
          itemPerPage
        );
      }
    });
  }

  onNewClick() {
    if (this.props.onDocNew !== undefined) {
      this.props.onDocNew();
    }
  }

  onRowClick(row) {
    let { data } = this.state;
    //console.log('onRowClick',row,data[row])
    if (this.props.onRowSelect !== undefined) {
      this.props.onRowSelect(data[row]);
    }
  }

  onRenderColumn(data, col) {
    if (col === 5) {
      return this.renderStatus(data);
    } else {
      return <span>{data}</span>;
    }
  }

  onTextChange(e) {
    let { credit } = this.state;
    credit = e.target.value;
    this.setState({ credit: credit });
  }

  onTextSelect(e) {
    let { credit } = this.state;
    credit = e;
    this.setState({ credit: credit });
  }

  onShopNameTextChange(e) {
    let { query } = this.state;
    query = e.target.value;
    this.setState({ query: query });
  }

  onShopNameTextSelect(e) {
    let { docType } = this.props;
    let { query, year, month, day, searchBy, itemPerPage } = this.state;
    query = e;
    this.setState({ query: query, activePage: 0 });
    let is_match = docType === "purchase" ? true : false;
    this.loadData(year, month, day, searchBy, e, 0, itemPerPage, is_match);
  }

  renderStatus(status) {
    status = status * 1;
    if (status === 1) {
      return <span className="label label-success">อนุมัติแล้ว</span>;
    } else if (status === 2) {
      return <span className="label label-primary">ได้รับของแล้ว</span>;
    } else if (status === 3) {
      return <span className="label label-primary">นำสินค้าเข้าคลังแล้ว</span>;
    } else if (status === 6) {
      return <span className="label label-danger">ไม่อนุมัติ</span>;
    } else {
      return <span></span>;
    }
  }

  loadExcelData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    is_match = false,
    is_check = false,
    callBack = undefined
  ) {
    let { loadData, docType } = this.props;
    this.setState({ loading: true });
    let that = this;
    if (loadData !== undefined) {
      if (docType === "purchase") {
        loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          "",
          is_match,
          function (result) {
            that.setState({ loading: false, dataExcel: result.data });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      } else if (docType === "invoice" || docType === "withholdingtax") {
        loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          "",
          is_check,
          function (result) {
            that.setState({ loading: false, dataExcel: result.data });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      } else {
        loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          "",
          function (result) {
            that.setState({ loading: false, dataExcel: result.data });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      }
    } else {
      this.setState({ loading: false, dataExcel: [] });
    }
  }

  loadExcelDataRange(
    start,
    end,
    searchBy,
    query,
    activePage,
    itemPerPage,
    is_check = false,
    callBack
  ) {
    let { loadDataRange, docType } = this.props;
    this.setState({ loading: true });
    let that = this;
    if (loadDataRange !== undefined) {
      if (docType === "invoice" || docType === "withholdingtax") {
        loadDataRange(
          start,
          end,
          searchBy,
          query,
          activePage,
          "",
          is_check,
          function (result) {
            that.setState({ loading: false, dataExcel: result.data });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      } else {
        loadDataRange(
          start,
          end,
          searchBy,
          query,
          activePage,
          "",
          function (result) {
            that.setState({ loading: false, dataExcel: result.data });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      }
    } else {
      this.setState({ loading: false, dataExcel: [] });
    }
  }

  loadData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    is_match = false,
    is_check = false,
    callBack
  ) {
    let { loadData, docType } = this.props;
    let { year_series } = this.state;
    this.setState({ loading: true });
    let that = this;
    if (loadData !== undefined) {
      this.setState({
        isRange: false,
        dayRange: day,
        monthRange: month,
        yearRange: year,
      });
      if (docType === "purchase") {
        loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage,
          is_match,
          function (result) {
            that.setState({
              loading: false,
              data: result.data,
              pageCount: Math.ceil(result[that.props.dataCount] / itemPerPage),
              sum_amount: result.sum_amount,
            });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      } else if (docType === "invoice" || docType === "withholdingtax") {
        loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage,
          is_check,
          function (result) {
            that.setState({
              loading: false,
              data: result.data,
              pageCount:
                itemPerPage > 0
                  ? Math.ceil(result[that.props.dataCount] / itemPerPage)
                  : 0,
              sum_amount: result.sum_amount,
            });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      } else if (docType === "partpricecompare") {
        loadData(
          year,
          month,
          day,
          searchBy,
          query,
          year_series,
          activePage,
          itemPerPage,
          function (result) {
            that.setState({
              loading: false,
              data: result.data,
              pageCount: Math.ceil(result[that.props.dataCount] / itemPerPage),
              sum_amount: result.sum_amount,
            });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      } else {
        loadData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage,
          function (result) {
            that.setState({
              loading: false,
              data: result.data,
              pageCount: Math.ceil(result[that.props.dataCount] / itemPerPage),
              sum_amount:
                typeof result.sum_amount !== "undefined"
                  ? result.sum_amount
                  : result.total_count,
            });
            if (callBack !== undefined) callBack(result.data);
          }
        );
      }
    } else {
      this.setState({ loading: false });
    }
  }

  loadDataRange(start, end, searchBy, query, activePage, itemPerPage) {
    let { loadDataRange } = this.props;
    this.setState({ loading: true });
    let that = this;
    if (loadDataRange !== undefined) {
      loadDataRange(
        start,
        end,
        searchBy,
        query,
        activePage,
        itemPerPage,
        function (result) {
          that.setState({
            loading: false,
            data: result.data,
            pageCount: Math.ceil(result[that.props.dataCount] / itemPerPage),
          });
        }
      );
    }
  }

  onEndDateRangeChange(e) {
    if (e !== "" && e !== undefined && e !== null) {
      let { year, month, day, searchBy, query, itemPerPage } = this.state;
      let _day = parseInt(e.substr(0, 2));
      let _month = parseInt(e.substr(3, 5));
      let _year = parseInt(e.substr(6, 10));
      this.setState({
        isRange: true,
        dayRange: _day,
        monthRange: _month,
        yearRange: _year,
        activePage: 0,
      });
      year = year - 543;
      _year = _year - 543;
      let start =
        (day === "0" || day === 0 ? 1 : day) +
        "/" +
        (month === "00" ? "1" : month) +
        "/" +
        year;
      let end = _day + "/" + _month + "/" + _year;
      this.loadDataRange(start, end, searchBy, query, 0, itemPerPage);
    }
  }

  onStartDateRangeChange(e) {
    if (e !== "" && e !== undefined && e !== null) {
      let { searchBy, query, itemPerPage } = this.state;
      let _day = e.substr(0, 2);
      let _month = e.substr(3, 2);
      let _year = e.substr(6, 10);
      this.setState({
        day: _day * 1,
        month: _month,
        year: _year * 1,
        isRange: false,
        activePage: 0,
      });
      this.loadData(_year, _month, _day, searchBy, query, 0, itemPerPage);
    }
  }

  onExcelFileSaver() {
    let { txtTable } = this.props;
    const boxTitile = (txtTable ? "ตาราง" : "") + this.props.title;
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableId)
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const fileName = boxTitile + ".xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
  }

  onExportExcel() {
    let {
      year,
      month,
      day,
      searchBy,
      query,
      activePage,
      itemPerPage,
      yearRange,
      monthRange,
      dayRange,
    } = this.state;
    if (!this.state.isRange) {
      if (
        this.props.docType === "invoice" ||
        this.props.docType === "withholdingtax"
      ) {
        this.loadExcelData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage,
          false,
          true,
          () => {
            this.onExcelFileSaver();
          }
        );
      } else {
        this.loadExcelData(
          year,
          month,
          day,
          searchBy,
          query,
          activePage,
          itemPerPage,
          false,
          false,
          () => {
            this.onExcelFileSaver();
          }
        );
      }
    } else {
      year = year - 543;
      yearRange = yearRange - 543;
      let start =
        (day === "0" || day === 0 ? 1 : day) +
        "/" +
        (month === "00" ? "1" : month) +
        "/" +
        year;
      let end = dayRange + "/" + monthRange + "/" + yearRange;
      this.loadExcelDataRange(
        start,
        end,
        searchBy,
        query,
        activePage,
        itemPerPage,
        false,
        () => {
          this.onExcelFileSaver();
        }
      );
    }
  }

  onTypeExcelSelect(type) {
    if (this.props.onTypeExcelSelect !== undefined) {
      this.props.onTypeExcelSelect(type, () => {
        this.onExportExcel();
      });
    }
  }

  renderWCalendar() {
    return (
      <div style={{ display: "inline-flex" }}>
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            (this.state.day == "00" ? this.state.dayRange : this.state.day) +
            "/" +
            this.state.month +
            "/" +
            this.state.year
          }
          onChange={this.onStartDateRangeChange.bind(this)}
          maxWidth={"100%"}
        />
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            this.state.dayRange +
            "/" +
            this.state.monthRange +
            "/" +
            this.state.yearRange
          }
          onChange={this.onEndDateRangeChange.bind(this)}
          maxWidth={"100%"}
        />
      </div>
    );
  }

  renderToolbar() {
    let { searchOptions, docType } = this.props;
    let {
      credit,
      showCountCredit,
      showInsurance,
      isShopName,
      optionsShopName,
    } = this.state;
    let optionsCredit = [
      { id: "30", label: "30" },
      { id: "45", label: "45" },
      { id: "60", label: "60" },
      { id: "90", label: "90" },
    ];
    return (
      <Form inline style={{ marginBottom: "5px" }}>
        <FormGroup>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>{" "}
        <FormGroup
          style={{ display: this.props.showCategorySelect ? "" : "none" }}
        >
          <Select
            value={this.state.searchBy}
            options={searchOptions}
            clearable={false}
            onChange={this.onSearchOptionChange.bind(this)}
            style={{ width: "180px" }}
          />
        </FormGroup>{" "}
        <FormGroup style={{ display: this.props.showTextSearch ? "" : "none" }}>
          {showInsurance ? (
            <Select
              value={this.state.insuranceName}
              options={this.state.insuranceOption}
              clearable={false}
              onChange={this.onInsuranceOptionChange.bind(this)}
              style={{ width: "320px" }}
            />
          ) : isShopName && docType == "purchase" ? (
            <CKAutocomplete
              placeholder="ค้นหา..."
              top={"-34px"}
              width={"200px"}
              items={optionsShopName}
              value={this.state.query}
              onChange={this.onShopNameTextChange.bind(this)}
              onSelect={this.onShopNameTextSelect.bind(this)}
            />
          ) : (
            <div className="input-group">
              <FormControl
                value={this.state.query}
                placeholder="ค้นหา..."
                onKeyPress={this.onSearchKeyPress.bind(this)}
                onChange={this.onQueryChange.bind(this)}
                style={{ zIndex: "0" }}
              />
              <span className="input-group-btn" style={{ zIndex: "0" }}>
                <Button
                  className="btn-flat"
                  onClick={this.onSearchClick.bind(this)}
                >
                  <FontAwsome name="search" />
                </Button>
              </span>
            </div>
          )}
        </FormGroup>{" "}
        {docType === "taxinvoice" ? (
          <FormGroup>
            <DropdownButton
              className="bg-green"
              title={
                <span>
                  <FontAwesome name="file-excel-o" /> ออกไฟล์ Excel
                </span>
              }
              id={"print-taxinvoice-excel-options"}
              onSelect={this.onTypeExcelSelect.bind(this)}
            >
              <MenuItem eventKey={"all"}>
                <FontAwesome name="table" />
                &nbsp;ตารางรวมทั้งหมด
              </MenuItem>
              <MenuItem eventKey={"taxinvoice"}>
                <FontAwesome name="table" />
                &nbsp;ตารางภาษี-ขาย
              </MenuItem>
            </DropdownButton>
          </FormGroup>
        ) : (
          <FormGroup>
            <PrintButtons
              onExportExcel={this.onExportExcel.bind(this)}
              marginLeft="0"
              width="auto"
            />
          </FormGroup>
        )}{" "}
        <FormGroup style={{ display: !showCountCredit ? "none" : "" }}>
          <ControlLabel>จำนวนวันเครดิต</ControlLabel>{" "}
          <CKAutocomplete
            top={"-34px"}
            width={"100px"}
            items={optionsCredit}
            value={credit}
            onChange={this.onTextChange.bind(this)}
            onSelect={this.onTextSelect.bind(this)}
          />
        </FormGroup>{" "}
        <FormGroup
          style={{
            display:
              this.props.showSelectMenu && this.props.showCreate && false
                ? ""
                : "none",
          }}
        >
          <Button bsStyle="primary" onClick={this.props.onMenuClick}>
            <FontAwsome name="pencil" /> {this.props.selectMenuTitle}
          </Button>
        </FormGroup>
        <FormGroup
          style={{
            display:
              this.props.showSelectMenu && this.props.showCreate ? "" : "none",
          }}
        >
          <DropdownButton
            bsStyle={"primary"}
            title={
              this.props.selectMenuTitle == undefined
                ? ""
                : this.props.selectMenuTitle
            }
            id={"gen-menu-options"}
            onSelect={this.props.onMenuClick}
          >
            {this.props.selectMenuOption.map((item, index) => (
              <MenuItem key={index} eventKey={item.eventKey}>
                <FontAwesome name={item.icon} className={item.className} />
                &nbsp;{item.title}
              </MenuItem>
            ))}
          </DropdownButton>
        </FormGroup>{" "}
        <FormGroup style={{ display: this.props.showSelectMenu ? "" : "none" }}>
          {this.props.docType === "taxinvoice" ? (
            this.renderTaxinvoiceDropdownButtonPrint()
          ) : this.props.docType === "invoice" ||
            this.props.docType === "withholdingtax" ? (
            this.renderInvoiceDropdownButtonPrint()
          ) : (
            // :this.props.docType==='creditnote'
            // ?
            // this.renderCreditNoteDropdownButtonPrint()
            <Button bsStyle="danger" onClick={this.props.onPrintClick}>
              <FontAwsome name="print" />
              &nbsp;{this.props.printTitle}
            </Button>
          )}
        </FormGroup>{" "}
        {docType === "partpricecompare" &&
        this.state.searchBy === "brand_model" ? (
          <FormGroup>
            <ControlLabel>ปีรถ</ControlLabel>{" "}
            <FormControl
              placeholder="ค้นหาปีรถ..."
              value={this.state.year_series}
              onChange={this.onYearSeriesChange.bind(this)}
              onKeyPress={this.onYearSeriesKeyPress.bind(this)}
              style={{ zIndex: "0" }}
            />
          </FormGroup>
        ) : (
          ""
        )}
      </Form>
    );
  }

  // renderCreditNoteDropdownButtonPrint() {
  //   return(
  //     <div>
  //       <DropdownButton bsStyle={'primary'} title={'สร้างใบลดหนี้/เพิ่มหนี้'} id={'print-creditnote-menu-options'} onSelect={this.props.onCreditNotePrintSelect}>
  //         <MenuItem eventKey={0}><FontAwesome name='file' />&nbsp;ใบลดหนี้</MenuItem>
  //         <MenuItem eventKey={1}><FontAwesome name='file' />&nbsp;ใบเพิ่มหนี้</MenuItem>
  //       </DropdownButton>
  //       &nbsp;
  //       <DropdownButton bsStyle={'danger'} title={this.props.printTitle} id={'print-creditnote-doc-menu-options'} onSelect={this.props.onTypePrintSelect}>
  //         <MenuItem eventKey={0}><FontAwesome name='file' />&nbsp;พิมพ์ใบวางบิลแบบทั่วไป</MenuItem>
  //         <MenuItem eventKey={1}><FontAwesome name='file' />&nbsp;พิมพ์ใบวางบิลแบบประกัน</MenuItem>
  //         <MenuItem eventKey={2}><FontAwesome name='file' />&nbsp;พิมพ์ใบจ่าหน้าซอง</MenuItem>
  //       </DropdownButton>
  //     </div>
  //   )
  // }

  renderInvoiceDropdownButtonPrint() {
    let { docType } = this.props;
    return (
      <DropdownButton
        bsStyle={"danger"}
        title={this.props.printTitle}
        id={"print-invoice-menu-options"}
        onSelect={this.props.onTypePrintSelect}
      >
        <MenuItem
          style={{ display: docType === "withholdingtax" ? "none" : "" }}
          eventKey={0}
        >
          <FontAwesome name="file" />
          &nbsp;พิมพ์ใบวางบิล
        </MenuItem>
        <MenuItem eventKey={1}>
          <FontAwesome name="file" />
          &nbsp;พิมพ์ใบจ่าหน้าซอง
        </MenuItem>
      </DropdownButton>
    );
  }

  renderTaxinvoiceDropdownButtonPrint() {
    return (
      <div>
        <DropdownButton
          bsStyle={"primary"}
          title={"สร้างใบลดหนี้/เพิ่มหนี้"}
          id={"print-creditnote-menu-options"}
          onSelect={this.props.onCreditNotePrintSelect}
        >
          <MenuItem eventKey={0}>
            <FontAwesome name="file" />
            &nbsp;ใบลดหนี้
          </MenuItem>
          <MenuItem eventKey={1}>
            <FontAwesome name="file" />
            &nbsp;ใบเพิ่มหนี้
          </MenuItem>
          <MenuItem eventKey={2}>
            <FontAwesome name="file" />
            &nbsp;ใบสำคัญรับ
          </MenuItem>
        </DropdownButton>
        &nbsp;
        <DropdownButton
          bsStyle={"danger"}
          title={this.props.printTitle}
          id={"print-taxinvoice-menu-options"}
          onSelect={this.props.onTypePrintSelect}
        >
          <MenuItem eventKey={0}>
            <FontAwesome name="file" />
            &nbsp;พิมพ์ใบวางบิลแบบทั่วไป
          </MenuItem>
          <MenuItem eventKey={1}>
            <FontAwesome name="file" />
            &nbsp;พิมพ์ใบวางบิลแบบประกัน
          </MenuItem>
          <MenuItem eventKey={2}>
            <FontAwesome name="file" />
            &nbsp;พิมพ์ใบจ่าหน้าซอง
          </MenuItem>
        </DropdownButton>
      </div>
    );
  }

  renderBodyColumn(
    rows,
    excludedColumns,
    excludeClickColumn,
    onRenderColumn,
    onRowClick
  ) {
    let { bodyColumn } = this.props;
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = bodyColumn.map((key, kid) => {
        const formattedValue = tableHelper.formatValue(row, key);
        const tdClass =
          isNaN(row[key]) || row[key] === "" || row[key] === null
            ? "text-left"
            : key == "check"
            ? "text-center"
            : "text-right";
        if (
          excludeClickColumn !== undefined &&
          excludeClickColumn.includes(key)
        ) {
          return (
            <td className={tdClass} key={kid + 1}>
              {onRenderColumn(formattedValue, key, row, index, kid)}
            </td>
          );
        } else {
          return (
            <td
              className={tdClass}
              key={kid + 1}
              onClick={() => {
                onRowClick(index);
              }}
            >
              {onRenderColumn(formattedValue, key, row, index, kid)}
            </td>
          );
        }
      });

      return <tr key={index}>{tds}</tr>;
    });
  }

  renderExcelBodyColumn(
    rows,
    excludedColumns,
    excludeClickColumn,
    onRenderColumn,
    onRowClick
  ) {
    let { bodyColumn, excelType } = this.props;
    const exBodyColumn =
      excelType === "taxinvoice"
        ? [
            "doc_date",
            "bill_no",
            "customer_name",
            "amount_before_vat",
            "vat",
            "amount",
          ]
        : bodyColumn;
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = exBodyColumn.map((key, kid) => {
        const formattedValue = tableHelper.formatValue(row, key);
        const tdClass =
          isNaN(row[key]) || row[key] === "" || row[key] === null
            ? "text-left"
            : key == "check"
            ? "text-center"
            : "text-right";
        if (
          excludeClickColumn !== undefined &&
          excludeClickColumn.includes(key)
        ) {
          return (
            <td className={tdClass} key={kid + 1}>
              {onRenderColumn(formattedValue, key, row, index, kid)}
            </td>
          );
        } else {
          return (
            <td
              className={tdClass}
              key={kid + 1}
              onClick={() => {
                onRowClick(index);
              }}
            >
              {onRenderColumn(formattedValue, key, row, index, kid)}
            </td>
          );
        }
      });

      return <tr key={index}>{tds}</tr>;
    });
  }

  renderExcelRowData() {
    let {
      headerTitles,
      headerExcelTitles,
      excludeColumn,
      excludeClickColumn,
      bodyColumn,
      excelType,
      onRenderColumn,
      onRenderExcelColumn,
    } = this.props;
    const dataRows = this.state.dataExcel.map((row, rid) => {
      const newRow = JSON.parse(JSON.stringify(row));
      if (excelType === "taxinvoice") {
        let newExcelRow = {
          doc_date: newRow.doc_date,
          bill_no: newRow.bill_no,
          customer_name: newRow.customer_name,
          amount_before_vat: newRow.amount_before_vat,
          vat: newRow.vat,
          amount: newRow.amount,
        };
        return newExcelRow;
      } else return newRow;
    });

    let renderColumn =
      excelType === "taxinvoice"
        ? onRenderExcelColumn !== undefined
          ? onRenderExcelColumn
          : this.onRenderColumn.bind(this)
        : onRenderColumn !== undefined
        ? onRenderColumn
        : this.onRenderColumn.bind(this);
    if (dataRows.length === 0) {
      return (
        <tr>
          <td
            colSpan={
              excelType === "taxinvoice"
                ? headerExcelTitles.length
                : headerTitles.length
            }
          >
            ไม่พบข้อมูล
          </td>
        </tr>
      );
    }
    if (bodyColumn !== undefined) {
      return this.renderExcelBodyColumn(
        dataRows,
        excludeColumn,
        excludeClickColumn,
        renderColumn,
        this.onRowClick.bind(this)
      );
    }
    return tableHelper.renderRowsCustom(
      dataRows,
      excludeColumn,
      excludeClickColumn,
      renderColumn,
      this.onRowClick.bind(this)
    );
  }

  renderRowData() {
    let { headerTitles, excludeColumn, excludeClickColumn, bodyColumn } =
      this.props;
    const dataRows = this.state.data.map((row, rid) => {
      const newRow = JSON.parse(JSON.stringify(row));
      return newRow;
    });

    let renderColumn =
      this.props.onRenderColumn !== undefined
        ? this.props.onRenderColumn
        : this.onRenderColumn.bind(this);

    if (dataRows.length === 0) {
      return (
        <tr>
          <td colSpan={headerTitles.length}>ไม่พบข้อมูล</td>
        </tr>
      );
    }
    if (bodyColumn !== undefined) {
      return this.renderBodyColumn(
        dataRows,
        excludeColumn,
        excludeClickColumn,
        renderColumn,
        this.onRowClick.bind(this)
      );
    }
    return tableHelper.renderRowsCustom(
      dataRows,
      excludeColumn,
      excludeClickColumn,
      renderColumn,
      this.onRowClick.bind(this)
    );
  }

  getDate() {
    let { day, month, year, isRange, dayRange, monthRange, yearRange } =
      this.state;
    if (isRange === "true") {
      let start =
        (day === "0" || day === 0 ? 1 : day) +
        "/" +
        (month === "00" ? "1" : month) +
        "/" +
        (year - 543);
      let end = dayRange + "/" + monthRange + "/" + (yearRange - 543);
      return "ประจำวันที่ " + start + " - " + end;
    } else {
      let text = "ประจำวันที่ ";
      text += day + " " + momentHelper.getMonthText(month) + " " + (year - 543);
      if (year === "0" || year === "00" || year === 0) {
        text = "ทั้งหมด";
      } else if (month === "0" || month === "00" || month === 0) {
        text = "ประจำปี " + (year - 543);
      } else if (day === "0" || day === "00" || day === 0) {
        text =
          "ประจำเดือน " + momentHelper.getMonthText(month) + " " + (year - 543);
      }
      return text;
    }
  }

  renderExcelTable() {
    let {
      headerTitles,
      headerExcelTitles,
      customExcelFooter,
      title,
      excelType,
    } = this.props;
    // add status text component to data array
    // let renderColumn = (this.props.onRenderColumn!==undefined)?this.props.onRenderColumn:this.onRenderColumn.bind(this)
    let renderRowData =
      this.props.renderRowData !== undefined
        ? this.props.renderRowData
        : this.renderExcelRowData.bind(this);

    return (
      <div className="table-responsive">
        <table
          id={this.refTableId}
          className="table table-hover table-bordered-solid"
          style={{ display: "none", minWidth: this.props.minWidth + "px" }}
        >
          <thead>
            <tr>
              {excelType === "taxinvoice" ? "" : <th></th>}
              <th
                className="text-center"
                colSpan={
                  excelType === "taxinvoice"
                    ? headerExcelTitles.length
                    : headerTitles.length - 1
                }
              >
                {excelType === "taxinvoice" ? "ภาษี - ขาย" : title}
              </th>
            </tr>
            <tr>
              {excelType === "taxinvoice" ? "" : <th></th>}
              <th
                className="text-center"
                colSpan={
                  excelType === "taxinvoice"
                    ? headerExcelTitles.length
                    : headerTitles.length - 1
                }
              >
                {this.getDate()}
              </th>
            </tr>
          </thead>
          {tableHelper.renderHeaderCustom(
            excelType === "taxinvoice" ? headerExcelTitles : headerTitles,
            this.onRenderCheckAll()
          )}
          <tbody>{renderRowData(this.state.dataExcel)}</tbody>
          {customExcelFooter
            ? this.props.renderCustomExcelFooter(this.state.dataExcel)
            : tableHelper.renderHeaderCustom(
                headerTitles,
                this.onRenderCheckAll()
              )}
        </table>
      </div>
    );
  }

  renderTable() {
    let { headerTitles, customFooter } = this.props;

    // add status text component to data array

    // let renderColumn = (this.props.onRenderColumn!==undefined)?this.props.onRenderColumn:this.onRenderColumn.bind(this)
    let renderRowData =
      this.props.renderRowData !== undefined
        ? this.props.renderRowData
        : this.renderRowData.bind(this);
    return (
      <div className="table-responsive">
        <table
          className="table table-hover table-bordered-solid"
          style={{ minWidth: this.props.minWidth + "px" }}
        >
          {tableHelper.renderHeaderCustom(
            headerTitles,
            this.onRenderCheckAll()
          )}
          <tbody>{renderRowData(this.state.data)}</tbody>
          {customFooter
            ? this.props.renderCustomFooter(this.state.data)
            : tableHelper.renderHeaderCustom(
                headerTitles,
                this.onRenderCheckAll()
              )}
        </table>
      </div>
    );
  }

  onRenderCheckAll() {
    return this.props.onRenderCheckAll();
  }

  onPrintClick(e) {
    let { month, day } = this.state;
    let year = this.state.year - 543;
    let url = "";
    if (process.env.NODE_ENV == "development") {
      url =
        "https://demo2.bigfix.co/korat/pdf/?doc_type=" +
        this.props.docType +
        "/" +
        this.props.viewMode +
        "&year=" +
        year +
        "&month=" +
        month +
        "&day=" +
        day +
        "&file=invoicereporttable_doc";
    } else {
      url =
        "./pdf/?doc_type=" +
        this.props.docType +
        "/" +
        this.props.viewMode +
        "&year=" +
        year +
        "&month=" +
        month +
        "&day=" +
        day +
        "&file=invoicereporttable_doc";
    }

    this.refs.iframe.loadUrl(url);
  }

  getStartDateRangeText() {
    let { day, month, year } = this.state;
    day = day == 0 ? 1 : day;
    let txtMonth = momentHelper.getMonthText(month.toString()); // this.getMonthText(month)
    return day + " " + txtMonth + " " + year;
  }

  getEndDateRangeText() {
    let { dayRange, monthRange, yearRange } = this.state;
    dayRange = dayRange == 0 ? 1 : dayRange;
    let txtMonth = momentHelper.getMonthText(monthRange.toString()); // this.getMonthText(monthRange)
    return dayRange + " " + txtMonth + " " + yearRange;
  }

  onRangeClearClick() {
    let { year, month, day, searchBy, query, itemPerPage } = this.state;
    this.loadData(year, month, day, searchBy, query, 0, itemPerPage);
    this.setState({
      isRange: false,
      dayRange: day,
      monthRange: month,
      yearRange: year,
      activePage: 0,
    });
  }

  // renderPaging() {
  //   return (
  //     <Row>
  //       <Col md={12} >
  //         <ReactPaginate
  //           forcePage={this.state.activePage}
  //           previousLabel={"ก่อนหน้า"}
  //           nextLabel={"ถัดไป"}
  //           breakLabel={<a href="">...</a>}
  //           breakClassName={"break-me"}
  //           pageCount={this.state.pageCount}
  //           marginPagesDisplayed={2}
  //           pageRangeDisplayed={2}
  //           onPageChange={this.onPageChange.bind(this)}
  //           containerClassName={"pagination pull-right"}
  //           subContainerClassName={"pages pagination"}
  //           activeClassName={"active"} />
  //       </Col>
  //     </Row>
  //   )
  // }

  renderPaging() {
    let { sum_amount } = this.state;
    let { docType } = this.props;
    return (
      <Row>
        <Col md={12} className="text-right">
          <Form inline>
            <FormGroup>จำนวนแถวต่อหน้า</FormGroup>{" "}
            <FormGroup>
              <DropdownButton
                id="gentb-row-per-page"
                bsStyle={"default"}
                title={
                  this.state.itemPerPage === 0 ? "All" : this.state.itemPerPage
                }
                onSelect={this.onRowsPerPageChange.bind(this)}
              >
                {this.state.optionsRows.map((item, index) => (
                  <MenuItem key={index} eventKey={item}>
                    {item === 0 ? "All" : item}
                  </MenuItem>
                ))}
              </DropdownButton>
            </FormGroup>{" "}
            <FormGroup>
              <ReactPaginate
                forcePage={this.state.activePage}
                previousLabel={"ก่อนหน้า"}
                nextLabel={"ถัดไป"}
                breakLabel={<a href="">...</a>}
                breakClassName={"break-me"}
                pageCount={this.state.pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={this.onPageChange.bind(this)}
                containerClassName={"pagination pull-right"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </FormGroup>{" "}
            <FormGroup
              style={{ display: sum_amount !== undefined ? "" : "none" }}
            >
              {["stockcheckdoc", "stockanyexport"].includes(docType)
                ? "จำนวนทั้งหมด"
                : "ยอดรวมทั้งหมด"}{" "}
              {["stockcheckdoc", "stockanyexport"].includes(docType)
                ? sum_amount
                : this.getNumberFormat(sum_amount)}{" "}
              {["stockcheckdoc", "stockanyexport"].includes(docType)
                ? "รายการ"
                : "บาท"}
            </FormGroup>
          </Form>
        </Col>
      </Row>
    );
  }

  renderDateRange() {
    let { isRange } = this.state;
    if (isRange) {
      return (
        <div style={{ marginBottom: "10px", display: "flex" }}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;
          <Button
            className="btn btn-xs"
            onClick={this.onRangeClearClick.bind(this)}
          >
            <FontAwesome name="eraser" />
            &nbsp;ลบช่วงเวลา
          </Button>
        </div>
      );
    } else {
      return "";
    }
  }

  renderMobileTable() {
    let { data } = this.state;
    let fieldMap = this.props.mobileFieldMap;
    return (
      <div>
        <ReportMobileTable
          itemlist={data}
          fieldMap={fieldMap}
          renderWorkStatus={this.props.renderWorkStatus}
          onRowClick={(value, item, index) => {
            this.onRowClick(index);
          }}
          numberFormat={this.props.numberFormat}
        />
      </div>
    );
  }

  render() {
    let {
      showNewButton,
      showPrintButton,
      isMobile,
      txtTable,
      showTitle,
      border,
    } = this.props;
    const boxTitile = (txtTable ? "ตาราง" : "") + this.props.title;
    let newTitle =
      this.props.newTitle !== undefined
        ? this.props.newTitle
        : "เพิ่ม" + this.props.title;
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={border}>
          <Box.Title>{showTitle ? boxTitile : ""}</Box.Title>
          <Box.Tools>
            <Button
              style={{ display: showNewButton ? "" : "none" }}
              bsStyle={"link"}
              className="text-large"
              onClick={this.onNewClick.bind(this)}
            >
              <FontAwsome name="plus" />
              &nbsp;{newTitle}
            </Button>
            <Button
              style={{ display: showPrintButton ? "" : "none" }}
              className="bg-maroon"
              onClick={this.onPrintClick.bind(this)}
            >
              <FontAwesome name="print" />
              &nbsp;{this.props.btnTitlePrint}
            </Button>
            {this.props.renderToolBtn != undefined
              ? this.props.renderToolBtn()
              : ""}
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {isMobile ? this.renderMobileTable() : this.renderTable()}
          {this.renderExcelTable()}
          {this.renderPaging()}
          <IframeModal ref="iframe" title={this.props.btnTitlePrint} />
        </Box.Body>
      </Box>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
});

ReportGeneralTable.defaultProps = {
  onRenderCheckAll: () => {},
  title: "ใบสั่งซื้อ",
  showNewButton: true,
  loadOnShow: false,
  show: false,
  minWidth: 900,
  btnTitlePrint: "พิมพ์เอกสาร",
  showCreate: false,
  customFooter: false,
  customExcelFooter: false,
  selectMenuOption: [],
  showCategorySelect: true,
  showTextSearch: true,
  viewMode: "",
  docType: "",
  numberFormat: true,
  bodyColumn: undefined,
  autoRowSelect: undefined,
  autoQuery: null,
  txtTable: true,
  dataCount: "data_count",
  showTitle: true,
  border: true,
  callOut: false,
  headerExcelTitles: [],
};

export default ReportGeneralTable = connect(
  (state) => ({ messages: {}, siteLocation: state.siteLocation }),
  null,
  null,
  { withRef: true },
  null,
  null,
  { withRef: true },
  withSizes(mapSizesToProps)
)(ReportGeneralTable);



// WEBPACK FOOTER //
// ./src/view/report/ReportGeneralTable.js